module.exports = __webpack_public_path__ + "media/images/lb/069-5f2a4221b2ae15a4e365351f278e3f1b.svg";